import React from "react";
import "./FanJoinHead.css";
import { t } from "../i18n";

// ONE fan sign-up headline everywhere (founder, 1.5.1 #15): the gold trophy
// with the star fans earn beside it ("trophy alone feels bland, they earn
// stars"), "Make Requests, Earn Points!" and one line under it. `points`
// turns it into the just-earned version ("25 points earned!"). Each door
// keeps its own buttons and skip row: FanClaimPage (app fan start),
// FanSignInSheet (header chip), the empty My Requests gate and the
// after-paying sheet (FanRequestsPanel).
const FanJoinHead: React.FC<{ points?: number; size?: "md" | "sm" }> = ({ points, size = "md" }) => (
  <div className={`fanjoin fanjoin--${size}`}>
    <div className="fanjoin-icons" aria-hidden="true">
      <svg className="fanjoin-trophy" viewBox="0 0 24 24" fill="none" stroke="#ffd76a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 01-10 0zM7 6H4a3 3 0 003 3M17 6h3a3 3 0 01-3 3" />
      </svg>
      <svg className="fanjoin-star" viewBox="0 0 24 24">
        <path fill="#ffd76a" d="M12 2.4l2.95 5.98 6.6.96-4.78 4.65 1.13 6.57L12 17.46l-5.9 3.1 1.13-6.57L2.45 9.34l6.6-.96z" />
      </svg>
    </div>
    <div className="fanjoin-title">
      {points ? t("fanJoin.pointsEarned", { value: points.toLocaleString() }) : t("fanRequestsPanel.makeRequestsEarnPoints")}
    </div>
    <div className="fanjoin-sub">{points ? t("fanRequestsPanel.signUpToKeep") : t("fanJoin.climbTheLeaderboard")}</div>
  </div>
);

export default FanJoinHead;
